import { createSelector } from 'reselect';

export const selectCourses = createSelector(
  state => state.subscription.courses.courses.get('data'),
  courses => (courses ? courses.toJS() : null)
);

const courseIdMapper = course => course.get('id');
export const selectUserCourseIds = createSelector(
  state => state.subscription.user.getIn(['data', 'courses']),
  courses =>
    courses
      ? courses
          .filter(course => !!course.get('_pivot_charge_id'))
          .map(courseIdMapper)
          .toArray()
      : null
);

export const selectHasUserCompleted60Day = createSelector(
  state => state.subscription.courses.courses.get('data'),
  courses => courses.filter(course => course.get('sixty_day') && course.get('complete')).size > 0
);

export const select60DayCourse = createSelector(
  state => state.subscription.courses.courses.get('data'),
  courses => {
    const sixtyDayCourse = courses.find(course => course.get('sixty_day'));

    return sixtyDayCourse ? sixtyDayCourse.toJS() : null;
  }
);

export const selectCourse = createSelector(
  [(state, props) => state.subscription.courses.course.get('data'), (state, props) => props.match.params.courseId],
  (course, courseId) => (course && course.get('id').toString() === courseId ? course.toJS() : null)
);

const selectImmutableLessons = state => state.subscription.courses.course.getIn(['data', 'lessons']);
const selectImmutableChapter = (state, props) => {
  const course = state.subscription.courses.course;
  const id = props.match.params.chapterId;
  return course.hasIn(['data', 'chapters'])
    ? course.getIn(['data', 'chapters']).find(chapter => chapter.get('id').toString() === id)
    : null;
};
export const selectChapterLessons = createSelector(
  [selectImmutableLessons, selectImmutableChapter],
  (lessons, chapter) => {
    if (!lessons || !chapter) {
      return null;
    }
    return lessons.filter(lesson => lesson.get('chapter_id') === chapter.get('id')).toJS();
  }
);
export const selectChapter = createSelector(selectImmutableChapter, chapter => (chapter ? chapter.toJS() : null));

export const selectLesson = createSelector((state, props) => {
  const lessons = state.subscription.courses.course.getIn(['data', 'lessons']);
  return lessons && lessons.find(lesson => lesson.get('id').toString() === props.match.params.lessonId);
}, lesson => (lesson ? lesson.toJS() : null));

const lessonIdSelector = (state, props) => props.match.params.lessonId;
const courseSelector = (state, props) => state.subscription.courses.course.get('data');

export const selectHasLessonAccess = createSelector(
  [selectChapterLessons, lessonIdSelector, courseSelector],
  (lessons, lessonId, course) => {
    if (lessons && course) {
      const lessonIndex = lessons.findIndex(lesson => lesson.id.toString() === lessonId);
      return course.get('enrolled') && (lessonIndex === 0 || lessons[lessonIndex - 1].complete);
    }
    return false;
  }
);

const selectImmutableChapters = state => state.subscription.courses.course.getIn(['data', 'chapters']);
const selectImmutableCourse = state => state.subscription.courses.course.get('data');
export const selectHasChapterAccess = createSelector(
  [selectImmutableCourse, selectImmutableChapter, selectImmutableChapters],
  (course, chapter, chapters) => {
    const chapterIndex = chapters.findIndex(c => c.get('id') === chapter.get('id'));
    return course.get('enrolled') && (chapterIndex === 0 || chapters.get(chapterIndex - 1).get('complete'));
  }
);



// WEBPACK FOOTER //
// ./src/subscription/courses/redux/selectors.js